import React from 'react';
import { zodiacAppContent } from '../rich-content/zodiac-app-complete-content';
import { AutomaticPageBuilder } from '../page-sections/automatic-page-builder';

const ZodiacAppDetailPage = () => {
  return <AutomaticPageBuilder content={zodiacAppContent} />;
};

export default ZodiacAppDetailPage;
